import { List } from 'immutable';
import {
  confirmLexicalStateInCTAComponent,
  confirmLexicalStateInTextComponent,
} from 'modules/draftjs2lexical';
import * as lexicalHelpers from 'modules/Lexical/helpers';
import { DocumentsKey, Layer } from 'const';
import * as Models from 'models';
import { isCallToAction, isImage, isTextComponent } from 'utils/entityType';

export function getAbbreviationIdsFromRelationOrDocument(
  relation: Models.LayeredRelationMap,
  documents: Models.AppState.DocumentsMap,
  projectType: string,
): string[] {
  if (isImage(relation)) {
    // Abbreviation associations are defined on the original layer.
    return relation.getIn(['styles', Layer.ORIGINAL, 'abbreviations'], []); // ['912314','214124']
  }

  if (isTextComponent(relation)) {
  // Abbreviation markup is stored in the original lexical state, so use the original document when resolving abbreviations in Target mode.
    const originalDocumentId =
        relation?.getIn(['documentId', Layer.ORIGINAL]);

    const textComponent = documents.get(DocumentsKey.TEXT_COMPONENTS)?.get(originalDocumentId);

    if (!textComponent) {
      return [];
    }

    const styles = relation?.get('styles')?.get(Layer.ORIGINAL)?.toJS() as unknown as Models.TextRelationStyles | undefined;

    return lexicalHelpers.getAbbreviationIdsFromDocument(
      confirmLexicalStateInTextComponent(textComponent, styles ?? null),
    );
  }

  if (isCallToAction(relation)) {
    const callToAction: Models.CallToActionMap | undefined = documents.get(DocumentsKey.CALL_TO_ACTIONS)
      .get(relation.getIn(['documentId', Layer.ORIGINAL]));
    if (!callToAction) {
      return [];
    }
    const styles = relation?.get('styles')?.get(Layer.ORIGINAL)?.toJS() as Models.CallToActionStyles;

    return lexicalHelpers.getAbbreviationIdsFromDocument(
      confirmLexicalStateInCTAComponent(
        callToAction,
        styles,
        projectType,
      ),
    );
  }

  return [];
}

export function getAbbreviationIdsFromRelationsAndDocuments(
  relations: List<Models.LayeredRelationMap>,
  documents: Models.AppState.DocumentsMap,
  projectType: string,
): string[] {
  const abbreviationsIds: string[] = [];

  for (const relation of relations) {
    abbreviationsIds.push(
      ...getAbbreviationIdsFromRelationOrDocument(relation, documents, projectType),
    );
  }

  return abbreviationsIds;
}
